export function normalizeCpfDigits(value?: string | null): string {
  return (value ?? "").replace(/\D/g, "");
}

export function isCompleteDocument(digits: string): boolean {
  return digits.length === 11 || digits.length === 14;
}

export function resolveIdClienteForSubmit(params: {
  id_cliente?: number;
  linkedCpfDigits: string | null;
  cpfCnpj: string;
}): number | undefined {
  const cpfDigits = normalizeCpfDigits(params.cpfCnpj);
  if (!params.id_cliente || !params.linkedCpfDigits) return undefined;
  if (params.linkedCpfDigits !== cpfDigits) return undefined;
  return params.id_cliente;
}

export function buildLinkedCpfDigits(
  cpfCnpj: string,
  id_cliente?: number,
): string | null {
  const digits = normalizeCpfDigits(cpfCnpj);
  if (!id_cliente || !isCompleteDocument(digits)) return null;
  return digits;
}
